export const initialState = {
  userData: null,
  forms: null,
  stage: null,
  isLoading: false,
};
